<form [id]="formId" [formGroup]="formGroup" (submit)="submit()">
  @let name = formGroup.get('renterName')!;
  @let email = formGroup.get('email')!;
  @let dialCode = formGroup.get('dialCode')!;
  @let number = formGroup.get('number')!;
  @let address = formGroup.get('address')!;
  @let comment = formGroup.get('comment')!;

  <kendo-formfield>
    <kendo-label [text]="('renterInfo.name.label' | translate) + '*'">
      <kendo-textbox
        size="medium"
        showErrorIcon="initial"
        [formControlName]="name | controlName">
        <ng-template kendoPrefixTemplate>
          <kendo-svg-icon [icon]="icons.userIcon"/>
        </ng-template>
      </kendo-textbox>
    </kendo-label>
    <kendo-formerror [textContent]="'renterInfo.name.error' | translate"/>
  </kendo-formfield>
  <app-spacer/>
  <kendo-formfield>
    <kendo-label [text]="('renterInfo.email.label' | translate) + '*'">
      <kendo-textbox
        size="medium"
        showErrorIcon="initial"
        [formControlName]="email | controlName">
        <ng-template kendoPrefixTemplate>
          <kendo-svg-icon [icon]="icons.envelopIcon"/>
        </ng-template>
      </kendo-textbox>
    </kendo-label>
    @if (email.invalid && !email.untouched) {
      @if (email.hasError('required')) {
        <kendo-formerror [textContent]="'renterInfo.email.error' | translate"/>
      }
      @if (email.hasError('email')) {
        <kendo-formerror [textContent]="'renterInfo.email.invalid' | translate"/>
      }
    }
  </kendo-formfield>
  <app-spacer/>
  <kendo-label
    [ngClass]="{ 'k-color-error': (number.invalid && !number.untouched) || (dialCode.invalid && !dialCode.untouched) }"
    [text]="('renterInfo.phone.label' | translate) + '*'">
    <div class="row-items-left">
      <kendo-formfield>
        <kendo-combobox
          size="medium"
          [filterable]="true"
          [data]="filteredDialCodes"
          (filterChange)="filterDialCodes($event)"
          [formControlName]="dialCode | controlName"
          textField="label"
          valueField="id">
        </kendo-combobox>
        <kendo-formerror [textContent]="'renterInfo.phone.errorDialCode' | translate"/>
      </kendo-formfield>
      <kendo-formfield>
        <kendo-numerictextbox
          size="medium"
          format="##"
          [inputAttributes]="{inputmode: 'numeric'}"
          [decimals]="0"
          [min]="0"
          [spinners]="false"
          [formControlName]="number | controlName">
        </kendo-numerictextbox>
        <kendo-formerror [textContent]="'renterInfo.phone.errorPhone' | translate"/>
      </kendo-formfield>
    </div>
  </kendo-label>
  <app-spacer/>
  <kendo-formfield>
    <kendo-label [text]="('renterInfo.address.label' | translate) + '*'">
      <kendo-textbox
        size="medium"
        showErrorIcon="initial"
        [formControlName]="address | controlName">
        <ng-template kendoPrefixTemplate>
          <kendo-svg-icon [icon]="icons.homeIcon"></kendo-svg-icon>
        </ng-template>
      </kendo-textbox>
    </kendo-label>
    <kendo-formerror [textContent]="'renterInfo.address.error' | translate"/>
  </kendo-formfield>
  <app-spacer/>
  <kendo-formfield>
    <kendo-label [text]="'renterInfo.comment.label' | translate" [optional]="true">
      <kendo-label-messages [optional]="'optional' | translate | lowercase"/>
      <kendo-textarea
        style="height: auto;"
        size="medium"
        [rows]="5"
        [placeholder]="('renterInfo.comment.placeholder' | translate)"
        [formControlName]="comment | controlName">
      </kendo-textarea>
    </kendo-label>
  </kendo-formfield>

</form>
